import _ from "lodash";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import { getNextMenuRoute } from "Login/routes/Administrator/modules/AdministratorModule";
import { getRelativePath } from "Utils";
import SubMenuCurriculumWrapper from "Login/routes/Administrator/commonComponents/SubMenuCurriculumWrapper";

export default (store, isPlatform) => ({
  path: "learning-courses",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "learning-courses" */ "./components"),
      import(
        /* webpackChunkName: "learning-courses" */ "./modules/LearningCoursesModule"
      ),
      import(
        /* webpackChunkName: "studentslist" */ "SchoolSetup/modules/SchoolSetupModule"
      ),
    ]).then(([importedModule0, importedModule1, importedModule2]) => {
      const component = importedModule0.default;
      const reducer = importedModule1.default;
      const schoolSetupReducer = importedModule2.default;

      injectReducer(store, {
        key: "learningCourses",
        reducer,
      });

      injectReducer(store, {
        key: "schoolSetup",
        reducer: schoolSetupReducer,
      });

      return component;
    })
  ),
  onEnter(nextState, replace) {
    if (_.last(nextState.routes).path == "learning-courses" && !isPlatform) {
      const route = getNextMenuRoute("LEARNING_COURSE_SETUP");
      if (route) {
        replace(getRelativePath(route));
      } else {
        replace(getRelativePath("../"));
      }
    }
  },
  childRoutes: [SubMenuCurriculumWrapper(store)],
});
